import { createFileRoute } from '@tanstack/react-router'

import { LineItemImportPage } from '@/pages/line-items/import/LineItemImportPage'

export const Route = createFileRoute('/_authenticated/_dashboard/line-items/import/')({
  component: LineItemImportPage,
})
